// extracted by mini-css-extract-plugin
module.exports = {"regionFilters":"OffersListSection_regionFilters__3yxsr","regionButton":"OffersListSection_regionButton__rUOPp","noResults":"OffersListSection_noResults__6HmwV"};